<template>
  <div>
    <a href="#main" class="sr-only head__quick-link">본문 바로가기</a>
    <!-- Header -->
    <header class="head">
      <div class="layout-center-wrap head__inner">
        <router-link to="/" class="head__logo"
          ><img src="@/assets/img/svg/logo_make.svg" alt="한국인터넷진흥원"
        /></router-link>

        <div
          class="head__nav"
          @mouseover="!isMobile && (gnbOpen = true)"
          @mouseleave="!isMobile && (gnbOpen = false)"
          @focusout="!isMobile && handleFocusOut($event)"
        >
          <router-link
            v-for="(item, index) in menus"
            :key="item.id"
            :to="item.sub && item.sub.length > 0 ? item.sub[0].href : item.href"
            :aria-hidden="!isMobile && index !== 0 ? 'true' : 'false'"
            :tabindex="isMobile ? (gnbOpen ? 0 : -1) : index === 0 ? 0 : -1"
            class="head__nav__menu"
            :class="{ active: route.path.startsWith(item.href) }"
            @focus="!isMobile && openGnb()"
          >
            {{ item.title }}
          </router-link>
          <nav
            class="gnb"
            aria-label="주 메뉴"
            :class="{ 'is-open': gnbOpen }"
            ref="gnbNav"
          >
            <ul class="gnb__inner layout-center-wrap">
              <li
                v-for="(item, index) in menus"
                :key="item.id"
                class="gnb__depth1"
                :class="{ active: route.path.startsWith(item.href) }"
              >
                <component
                  :key="item.id"
                  :is="isMobile ? 'button' : 'a'"
                  :href="!isMobile ? item.href : undefined"
                  :type="isMobile ? 'button' : undefined"
                  class="gnb__depth1__menu"
                  :class="{ active: item.open, 'is-open': item.open }"
                  :aria-expanded="isMobile ? item.open : undefined"
                  :tabindex="
                    isMobile
                      ? gnbOpen
                        ? 0
                        : -1
                      : index === 0
                      ? gnbOpen
                        ? 0
                        : -1
                      : !gnbOpen
                      ? -1
                      : 0
                  "
                  @click="(e) => handleClick(item, e)"
                >
                  {{ item.title }}
                  <i class="svg_icon icon_arrow_down"></i>
                </component>
                <div
                  class="gnb__depth2"
                  :class="{
                    'is-open': item.open,
                    'is-closed': !item.open && isMobile,
                  }"
                  :aria-hidden="isMobile ? !item.open : false"
                >
                  <router-link
                    v-for="sub in item.sub"
                    :key="sub.id"
                    :to="sub.href"
                    class="gnb__depth2__menu"
                    :class="{ active: route.path === sub.href }"
                    @click.stop="closeGnb"
                    :tabindex="
                      gnbOpen && (isMobile ? item.open : true) ? 0 : -1
                    "
                  >
                    {{ sub.title }}
                  </router-link>
                </div>
              </li>
            </ul>
            <button
              type="button"
              class="btn_close"
              @click="closeGnb"
              :tabindex="isMobile && gnbOpen ? 0 : -1"
            >
              <i class="svg_icon icon_del" aria-hidden="true"></i>메뉴 닫기
            </button>
          </nav>
        </div>

        <div class="head__search" aria-label="사이트 통합 검색">
          <label class="sr-only" for="search">검색어를 입력하세요</label>
          <input
            v-model="searchInfo.content"
            type="text"
            placeholder="검색어를 입력하세요"
            @keyup.enter="search"
            id="search"
          />
          <button
            type="button"
            class="head__search__btn"
            aria-label="검색"
            @click="search"
          >
            <i class="svg_icon icon_search blue" aria-hidden="true">검색</i>
          </button>
        </div>

        <div class="head__btns">
          <button
            type="button"
            class="btn_mode BtnMode"
            @click="toggleDark"
            :aria-pressed="darkMode"
          >
            모드선택
          </button>
          <span class="sr-only">
            {{ darkMode ? "다크 모드 켜짐" : "다크 모드 꺼짐" }}
          </span>
        </div>

        <button
          type="button"
          class="btn_bar"
          @click="openGnb"
          :tabindex="isMobile ? 0 : -1"
          ref="btnBar"
        >
          <i class="svg_icon icon_bar" aria-hidden="true"></i>메뉴 열기
        </button>
      </div>
      <div class="head__path" v-if="showPath">
        <span class="sr-only" aria-label="현재 경로">
          홈
          <span v-if="currentDepth1?.title || pageTitle">></span>
          {{ currentDepth1 ? currentDepth1.title : pageTitle }}
          <span v-if="currentDepth2?.title">></span>
          {{ currentDepth2 ? currentDepth2.title : "" }}
        </span>
        <div
          class="head__path__inner layout-center-wrap"
          :tabindex="activeLayer !== null ? '0' : '-1'"
          :aria-hidden="activeLayer === null"
          ref="pathContainer"
        >
          <router-link to="/" class="head__path--home" tabindex="-1"
            ><i class="svg_icon path_home">홈으로</i></router-link
          >
          <div class="head__path__depth">
            <p class="head__path--now" @click="toggleLayer(1)">
              {{ currentDepth1 ? currentDepth1.title : pageTitle }}
            </p>
            <div
              class="head__path__layer"
              :class="{ active: activeLayer === 1 }"
            >
              <router-link
                v-for="item in menus"
                :key="item.id"
                :to="
                  item.sub && item.sub.length > 0 ? item.sub[0].href : item.href
                "
                class="head__path__menu"
                tabindex="-1"
                @click.stop="toggleLayer(null)"
              >
                {{ item.title }}
              </router-link>
            </div>
          </div>
          <div class="head__path__depth" v-if="currentDepth2">
            <p
              class="head__path--now"
              @click="toggleLayer(2)"
              v-if="currentDepth1 && currentDepth1.sub?.length"
            >
              {{ currentDepth2 ? currentDepth2.title : "" }}
            </p>
            <div
              class="head__path__layer"
              :class="{ active: activeLayer === 2 }"
            >
              <router-link
                v-for="sub in currentDepth1.sub"
                :key="sub.id"
                :to="sub.href"
                @click.stop="toggleLayer(null)"
                class="head__path__menu"
              >
                {{ sub.title }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import dc from "@/component/DataChk.js";
import { menu, singleMenuMap } from "@/menu/menu.js";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  setup() {
    const activeLayer = ref(null);
    const route = useRoute();
    const router = useRouter();

    // data 정의
    const gnbOpen = ref(false);
    const gnbNav = ref(null);
    const btnBar = ref(null);
    const pathContainer = ref(null);
    const isMobile = ref(false);
    const menus = reactive(menu);
    const darkMode = ref(false); //다크모드,라이트모드
    const currentDepth1 = ref(null); //선택된 1depth
    const searchInfo = ref({
      searchOption: "KEYWORD",
      content: "",
      collectionType: "",
      tabs: "ko",
    });

    // methods 정의
    const toggleLayer = (layer) => {
      activeLayer.value = activeLayer.value === layer ? null : layer;
    };

    const search = () => {
      if (!dc.nullChk(searchInfo.value.content)) {
        alert("검색어를 입력해주세요");
        return;
      }
      router.push({
        name: "keywordResult",
        query: searchInfo.value,
      });
    };

    // 초기 세팅
    const updateCurrentDepth1ByRoute = () => {
      const matched = menus.find((item) =>
        route.path.startsWith(`/${item.href.split("/")[1]}`)
      );
      currentDepth1.value = matched || null;
    };

    const toggleDark = () => {
      darkMode.value = !darkMode.value;
      document.body.classList.toggle("dark", darkMode.value);
      localStorage.setItem("darkMode", darkMode.value);
    };

    //태블릿, 모바일 메뉴 여닫기
    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 1399.9; // 태블릿/모바일 기준
    };

    const openCurrentMenu = () => {
      menus.forEach((m) => {
        if (route.path.startsWith(m.href)) {
          m.open = true;
        } else {
          m.open = false;
        }
      });
    };

    const handleClick = (item, e) => {
      e?.preventDefault?.();
      menus.forEach((m) => {
        if (m.id === item.id) {
          m.open = !m.open; // 클릭한 메뉴 토글
        } else {
          m.open = false; // 나머지는 닫기
        }
      });
    };

    function openGnb() {
      gnbOpen.value = true;

      if (isMobile.value) {
        nextTick(() => {
          gnbNav.value?.querySelector(".gnb__depth1__menu")?.focus();
        });
      }
    }
    function closeGnb() {
      gnbOpen.value = false;
      // 모든 1차 메뉴의 하위 메뉴를 닫습니다.
      menus.forEach((m) => {
        m.open = false;
      });

      if (isMobile.value) {
        nextTick(() => {
          btnBar.value?.focus();
        });
      }
    }
    // watch, computed 정의
    // 라우트가 바뀔 때마다 반영
    watch(
      () => route.path,
      () => {
        updateCurrentDepth1ByRoute();
      }
    );
    //path 데이터
    const pageTitle = computed(() => {
      return singleMenuMap[route.name] || "";
    });

    const showPath = computed(() => route.name !== "dashboard");

    //선택된 2depth
    const currentDepth2 = computed(() => {
      if (!currentDepth1.value) return null;
      const foundSub = currentDepth1.value.sub.find(
        (sub) => route.path === sub.href
      );
      const result = foundSub || currentDepth1.value.sub[0]; // 기본값
      return result;
    });

    const handleFocusOut = (event) => {
      const nav = event.currentTarget;
      // 포커스가 GNB 내부가 아니면 레이어 닫기
      if (!nav.contains(event.relatedTarget)) {
        closeGnb();
      }
    };

    const handleClickOutside = (event) => {
      if (
        activeLayer.value !== null &&
        pathContainer.value &&
        !pathContainer.value.contains(event.target)
      ) {
        toggleLayer(null);
      }
    };

    // life cycle 정의
    onMounted(() => {
      updateCurrentDepth1ByRoute();
      // 다크모드 체크
      const saved = localStorage.getItem("darkMode") === "true";
      darkMode.value = saved;
      if (saved) document.body.classList.add("dark");

      // 디바이스 체크
      checkMobile();
      window.addEventListener("resize", checkMobile);
      window.addEventListener("click", handleClickOutside);
      openCurrentMenu();
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("click", handleClickOutside);
    });

    // html에서 사용될 데이터 정의
    return {
      toggleLayer,
      activeLayer,
      showPath,
      menus,
      openGnb,
      closeGnb,
      handleClick,
      toggleDark,
      pageTitle,
      currentDepth2,
      currentDepth1,
      isMobile,
      gnbOpen,
      route,
      search,
      searchInfo,
      darkMode,
      btnBar,
      gnbNav,
      pathContainer,
      handleFocusOut,
    };
  },
};
</script>
<style lang="scss" scoped>
.com_center_wrap {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
